/**
 * @file canvas-consent-messages.ts
 * @description Мост кабинета и канвы для баннера согласия на cookie
 * (phase19.16, партия Р3г, v0.19.62; SB134 «на канве баннер виден, пока
 * открыта панель «Счётчики и cookie»»; макет uiux-r3.md §3.6 —
 * переключатель «Баннер / Настроить»). Контракт согласован с витриной
 * (web-storefront, apps/web components/site/builder/preview-bridge.ts).
 *
 * Кабинет → канва (маркер `source: "commora-admin"`):
 *  - `commora:canvas-consent { show, consent? }`:
 *      show    — `"banner"` баннер (панель открыта), `"settings"` — баннер и
 *                окно «Настроить», `null` — убрать (панель закрыта);
 *      consent — блок согласия по черновику, тот же, что сервер отдаёт витрине
 *                (`resolveSiteConsent(counters, { noticeAllowed, consentVersion: 0, policyHref })`);
 *                `consent.banner === null` — баннера на сайте не будет; без
 *                поля витрина берёт блок страницы.
 * Вид баннера (полоса или карточка, ширина, цвета) канва получает живой
 * темой — `commora:site-theme-preview` с разделом `theme.consentBanner`;
 * здесь его нет. Ответа нет (как у вида каталога): витрина, которая
 * сообщение не знает, его пропускает. Шлётся после каждой загрузки окна
 * канвы и после каждой правки.
 */

import type { PublicSiteConsentDto } from "@chaiberi/shared";

import type { ConsentCanvasView } from "./consent-platform";
import { CABINET_MESSAGE_SOURCE } from "./canvas-messages";

/** Тип сообщения кабинета: баннер согласия на канве. */
export const CANVAS_CONSENT_MESSAGE = "commora:canvas-consent";

export interface CanvasConsentMessage {
  readonly source: typeof CABINET_MESSAGE_SOURCE;
  readonly type: typeof CANVAS_CONSENT_MESSAGE;
  readonly show: ConsentCanvasView | null;
  readonly consent?: PublicSiteConsentDto;
}

/** Показать баннер (или баннер с окном «Настроить») по черновику. */
export function canvasConsentMessage(show: ConsentCanvasView, consent: PublicSiteConsentDto): CanvasConsentMessage {
  return { source: CABINET_MESSAGE_SOURCE, type: CANVAS_CONSENT_MESSAGE, show, consent };
}

/** Убрать баннер с канвы (панель закрыта). */
export function canvasConsentCloseMessage(): CanvasConsentMessage {
  return { source: CABINET_MESSAGE_SOURCE, type: CANVAS_CONSENT_MESSAGE, show: null };
}
